import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { LargeButton, ButtonType } from '@checkmarx/cx-ui';
import PortalTextBox from '../../portal/portalTextBox';
import IconComponent from '../../portal/iconComponent';

@inject('translationsStore', 'forgotPasswordStore', 'configurationsStore') @observer
export default class ForgotPasswordForm extends Component {

    componentWillMount() {
        
        this.props.forgotPasswordStore.reset();
    }

    handleUserNameChange = e => this.props.forgotPasswordStore.setUserName(e.target.value);
    handleUserNameOnBlur = e => this.props.forgotPasswordStore.validateUserName();

    handleTenantChange = e => this.props.forgotPasswordStore.setTenant(e.target.value);
    handleTenantOnBlur = e => this.props.forgotPasswordStore.validateTenant();

    handleSubmitForm = (e) => {
        
        e.preventDefault();
        
        const isValid = this.props.forgotPasswordStore.validateForm();

        if (isValid === false) {
            return;
        }
        
        this.props.forgotPasswordStore.forgotPassword().then(() => {
            this.props.handleResetPassword();
        });
        
    };

    render() {

        const { isError, errorMessage, inProgress,
             values, tenantValidationMessage, userNameValidationMessage } = this.props.forgotPasswordStore;
        const {isMultitenancyMode} = this.props.configurationsStore;

        const usernameField = <div>
                                <PortalTextBox
                                        hintText={this.props.translationsStore.translate('USER_NAME')}
                                        floatingLabelText={this.props.translationsStore.translate('USER_NAME')}
                                        disabled={inProgress}
                                        onChange={this.handleUserNameChange} 
                                        onBlur={this.handleUserNameOnBlur} 
                                        errorText={userNameValidationMessage}
                                        width='325px'
                                        value={values.userName}
                                />
                             </div>;
        const tenantField = isMultitenancyMode ? 
            (<div>
                <PortalTextBox 
                    id='txtTenant'
                    dataCy='tenant'
                    hintText={this.props.translationsStore.translate('ACCOUNT')}
                    floatingLabelText={this.props.translationsStore.translate('ACCOUNT')}
                    disabled={inProgress}
                    onChange={this.handleTenantChange}
                    onBlur={this.handleTenantOnBlur}
                    errorText={tenantValidationMessage}
                    width='325px'
                    value={values.tenant}
                    ref='tenant'
                />
            </div>) : null;

        const submitButton = <div>
                                <LargeButton
                                    type='submit'
                                    id='btnResetPassword'
                                    dataCy='reset-password-button'
                                    inProgress={inProgress}
                                    text={this.props.translationsStore.translate('RESET_PASSWORD')}
                                    style={{marginTop: '20px'}}
                                />
                            </div>;


        return(
            <div className='login-form'>
                <div className='general-form-wrapper forgot-password'>
                    
                    <div className={'form-validation-message-wrapper ' + (isError == true ? 'show' : '')}>
                        <span className='error-message'>
                            <IconComponent iconClassName='alert-error-icon' /> {errorMessage}
                        </span>
                    </div>

                    <div className='welcome-message-wrapper'>
                        <span>
                            {this.props.translationsStore.translate('FORGOT_PASSWORD_HEADER')}
                        </span>
                        <div>
                            {this.props.translationsStore.translate('ENTER_YOUR_USERNAME')}
                        </div>
                    </div>

                    <form onSubmit={this.handleSubmitForm}>
                        <div className='form-col'>
                            {usernameField}
                            {tenantField}
                            {submitButton}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/forgotPasswordFlow/forgotPasswordForm.jsx